<template>
  <div class="main-content">
    <div  class="profileView">
      <div class="plft">
        <div class="plft-prf v-flex align-items-center">
          <div class="prf-menu">
            <ul>
              <li v-if="hasPermission('Business Settings','view')">
                <router-link  
                  :to="{name : 'business_settings', params: {page:'business'} }"
                  class="v-flex align-items-center"
                  :class="{'active':state.businessView}">
                  <div v-html="icons.settings" class="ic"></div>
                  <span>Business Settings</span>
                  <span class="aln"></span>
                </router-link>
              </li>
              <li v-if="hasPermission('Accounting Settings','view')">
                <router-link  
                  :to="{name : 'business_settings', params: {page:'accounting'} }"
                  class="v-flex align-items-center"
                  :class="{'active':state.accountingView}">
                  <div v-html="icons.settings" class="ic"></div>
                  <span>Accounting Settings</span>
                  <span class="aln"></span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="pryt">
        <div class="text-center" v-if="!state.loaded">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        <div class="busn info" v-if="state.businessView && state.loaded">
          <DynamicForm :columns="1" 
              :fields="businessFields" @submit="updateBusiness" 
              :submitting="state.submitting" :errors="state.errors" 
              :success="state.success" />
        </div>
        <div class="payinfo info" v-if="state.accountingView && state.loaded">
          <DynamicForm :columns="1" 
              :fields="accountingFields" @submit="updateAccounting" 
              :submitting="state.submitting" :errors="state.errors" 
              :success="state.success" />
            <div v-if="profile.account=='full'">
              <DynamicForm :columns="1" 
                :fields="accountsFields" @submit="setAccounts" 
                :submitting="state.submitting2" :errors="state.errors2" 
                :success="state.success2" />
            </div>
        </div>
        <div class="acctinfo" v-if="state.acctView && state.loaded">

        </div>
      </div>
    </div>
  </div>

  
</template>

<script>
import icons from '@/assets/js/icons.js';
import { computed, defineComponent, ref, reactive, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
// import ModalView from '@/components/ModalView.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import { usePermissions } from '@/composables/usePermissions';

export default defineComponent({
  name: 'BusinessSettings',
  components:{DynamicForm},
  setup(){
    const accounts=ref([]);
    const router = useRouter();
    const { hasPermission } = usePermissions();
    const store= useStore();
    const user = computed(() => store.state.User.user);
    const route = useRoute();
    const page = computed(() => route.params.page)
    const svgIcons = ref(icons);
    const certForm=ref(null)
    const memForm=ref(null)
    const skillsForm=ref(null)
    const colors=["var(--primary-color)","#15ca20","#0dcaf0","#6627f1"];
    const state=reactive({businessView:false,accountingView:false,submitting:false,success:false,
      loaded:false, editPersonalModal:false,errors:[],
      submitting2:false,success2:false,errors2:[],
    });
    const profile=reactive({cname:"",sub_model:false,csm:"", account:""
    });
    
    const businessFields=reactive([
      { name: "Business Settings", number: "1",data: 
        [{ type: 'text', name: 'cname', label: 'Customer\'s Alias',
          value: profile.cname  },
          { type: 'text', name: 'csm', label: 'Account Manager\'s Alias',  
          value: profile.csm },
          { type: 'button', name: 'sub_model', label: 'Subscription Model',
          value: profile.sub_model }
        ]
      }
    ]);

    const accountingFields=reactive([
      { name: "Accounting Settings", number: "1",data: 
        [{ type: 'select', name: 'account', label: 'Accounting System',
          value: profile.account, options:
          [{label:"Simple (income and expense)",value:"simple"},{label:"Full (for expert accountants)",value:"full"}]  }
        ]
      }
    ]);

    const accountsFields=reactive([
      { name: "Assign Accounts", number: "1",data: 
        [
          { type: 'select', name: 'payroll', label: 'Payroll Account',
            value: "", options:accounts},
          { type: 'select', name: 'sub_acct', label: 'Subscription Account',
            value: "", options:accounts},
        ]
      }
    ]);

    onMounted(()=>{
    getPage()
    })

    function setTabs(){
      state.success=false;
      state.submitting=false;
      state.errors=[];
      state.businessView=false;
      state.accountingView=false;
      state.acctView=false;
      state.securityView=false;
      state.profView=false;
      switch(page.value){
        case "business":
          if(!hasPermission('Business Settings', 'view')){
            router.push({ name: 'unauthorized' });
            return;
          }
          state.businessView=true;
          break;
        case "accounting":
          if(!hasPermission('Accounting Settings', 'view')){
            router.push({ name: 'unauthorized' });
            return;
          }
          state.accountingView=true;
          break;
        default: 
          router.push({ name: 'unauthorized' });
          break;
      }
    }

    watch(
      () => route.params.page,
      () => {
       setTabs()
      }
    );

    function getPage(){
      setTabs()
      call({
        url:urls.business,
        data:{getBusinessSettings:""},
        success:(res)=>{
          profile.processing=false;
          if(res.status){
            state.loaded=true
            accounts.value=[];
            var msg=res.msg;
            var cinfo=res.msg.bset;
            profile.csm=cinfo.amalias;
            profile.sub_model=cinfo.sub;
            profile.cname=cinfo.calias;
            profile.account=cinfo.account;
            profile.payroll=cinfo.pay_acct;
            profile.sub_acct=cinfo.sub_acct;
            var i=0;
            for(i=0; i<businessFields.length; i++){
              businessFields[i].data.forEach(field => {
              if (profile[field.name]) {
                  field.value = profile[field.name];
                }
              });
            }
            for(i=0; i< accountingFields.length; i++){
              accountingFields[i].data.forEach(field => {
              if (profile[field.name]) {
                  field.value = profile[field.name];
                }
              });
            }
            for(i=0; i< accountsFields.length; i++){
              accountsFields[i].data.forEach(field => {
              if (profile[field.name]) {
                  field.value = profile[field.name];
                }
              });
            }
            Object.keys(msg.accounts).forEach(k => {
              accounts.value.push(msg.accounts[k])
            })
          }else{
            alert(res.msg)
          }
        }
      })
    }
    function setErrors(res){
      var errors=[];
      Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
          er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
      });
      state.errors=errors;
    }

    function updateBusiness(data){
      state.submitting=true;
      state.errors=[];
      data.updateBusiness="";
      call({
        url:urls.business,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
          }else{
            setErrors(res)
          }
        }
      })
    }

    function updateAccounting(data){
      state.submitting=true;
      state.errors=[];
      data.updateAccounting="";
      call({
        url:urls.business,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            location.reload();
          }else{
            setErrors(res)
          }
        }
      })
    }

    function setAccounts(data){
      state.submitting=true;
      state.errors=[];
      data.setAccounts="";
      call({
        url:urls.business,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            location.reload();
          }else{
            setErrors(res)
          }
        }
      })
    }

    return{profile,page,user,icons: svgIcons.value, state,getPage,updateAccounting,
      certForm,memForm,skillsForm,colors,updateBusiness,businessFields,accountingFields,
      accountsFields,setAccounts,hasPermission
    }
  }
})
</script>


<style lang="css" scoped>
  .profileView{background:var(--white-color);width: min(100%, 960px);
    display: flex; margin: 10px auto;}
  .plft{width: min(30%, 240px); border-right: 1px solid var(--data-table-border);}
  .plft-prf{margin:10px 0px; display:flex; flex-direction: column;
    min-height: 530px;}
  .prf-menu{width:100%}
  .prf-menu ul{padding-left:0; margin-bottom: 0; margin-top:0;}
  .prf-menu ul li{margin-bottom: 16px !important; margin-top:4px !important; 
  list-style: none;}
  .prf-menu ul li a{padding:12px 24px !important; font-size: 14px; color:var(--black);
    stroke:var(--black); fill: var(--black); position:relative;}
  .prf-menu ul li a .ic{width:18px; height:18px; margin-right:10px; display: flex;
    align-items: center; justify-content: center;}
  .prf-menu ul li a .ic svg{stroke-width: 0.4 !important;}
  .prf-menu ul li a .aln{position:absolute; right:0; width:2px; top:0; 
  height:100%; background: var(--primary-color); opacity:0;}
  .prf-menu ul li a.active{background: var(--profile-menu-hover); color:var(--primary-color);
  stroke: var(--primary-color);}
  .prf-menu ul li a.active .aln{opacity:1}

  .pryt{flex-grow: 1;flex-basis: 0;}
  .pinfo,.skils,.offinfo, .info{padding:20px;}
  
  @media screen and (max-width: 700px) {
    .profileView{flex-flow: column;}
    .plft{width:100%}
    .prf-menu ul{display: flex; gap: 5px; overflow-x: auto;}
    .plft-prf{min-height: auto;}
  }
</style>
